
import { Component, Vue, Prop } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import { addPrivilege } from "@/api/api-basic";
import { optionKey, getOptionList } from "@/api/api-dict";
import i18n from "@/config/i18n";
@Component({
  components: {}
})
export default class PiAddMenu extends Vue {
  @Prop({ default: "" }) private subSystemId!: string;
  private modalShow = false;
  private title = i18n.t("menuList.addAuto");

  private authList: object[] = [];
  private privilege: string[] = [];
  private formObj: objAny = {};
  private itemData: objAny = {};
  private formInline: objAny = {
    privilege: []
  };
  private ruleInline: objAny = {
    privilege: [
      {
        required: true,
        message: i18n.t("menuList.privilegePl"),
        trigger: "change"
      }
    ]
  };
  public open(item: objAny) {
    this.itemData = item;
    this.modalShow = true;
    const privilege: string[] = [];
    item.privilegeVoList.map((itemData: objAny) => {
      privilege.push(itemData.privilegeCode);
    });
    this.privilege = privilege;
    this.formInline.privilege = [];
    this.getOptionList();
  }
  public handleSubmit() {
    // console.log(this.formObj.validate);
    // this.formObj.validate((valid: boolean) => {
    //   alert("Aa");
    //   if (valid) {
    //     this.testSub();
    //   }
    // });
    this.testSub();
  }

  private subIndex = 0;
  public testSub() {
    const arr: object[] = [];
    this.subIndex = 0;
    this.authList.map((item: objAny, index: number) => {
      // && item.itemKey != "100501"
      if (this.formInline.privilege.indexOf(item.itemKey) != -1) {
        const data = {
          modulePkId: this.itemData.modulePkId,
          privilegeCode: item.itemKey,
          privilegeName: item.itemValue,
          sort: index + 1,
          subsystemPkId: this.itemData.subsystemPkId
        };
        arr.push(data);
      }
    });
    if (arr.length > 0) {
      this.subsub(arr);
    }
  }
  public subsub(arr: object[]) {
    if (this.subIndex < arr.length) {
      this.submitData(() => {
        this.subIndex++;
        this.subsub(arr);
      }, arr[this.subIndex]);
    } else {
      this.$Message.success(i18n.t("operationSucess"));
      this.$emit("success");
      this.modalShow = false;
    }
  }
  async submitData(callBack: Function, data: objAny): Promise<void> {
    const ret = await addPrivilege(data);

    if (ret.status === this.$config.apiStatus) {
      callBack && callBack();
    }
  }
  async getOptionList(): Promise<void> {
    const data = await getOptionList([optionKey.authObj]);
    this.authList = data[optionKey.authObj];
  }

  mounted() {
    this.formObj = this.$refs["formValidate"];
  }
}
